import { RemoteLoadRouteList } from '@/javascript/data/usecases/maps'
import { LoadRouteList } from '@/javascript/domain/usecases'
import { makeApiUrl} from '@/javascript/main/factories/http'
import { makeCurrentAccountHttpClientDecorator } from '@/javascript/main/factories/decorators'
import { makeRouteMapper } from '@/javascript/main/factories/mappers'

export const makeRemoteLoadRouteList = (): LoadRouteList =>
  new RemoteLoadRouteList(
    makeApiUrl('/maps/routes'),
    makeCurrentAccountHttpClientDecorator(),
    makeRouteMapper()
  )
